import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../modules/active_modal';
import { logoutStore } from '../modules/is_logged_in';
import CustomerCore           from './CustomerCore.jsx';
import CustomerPrefs          from './CustomerPrefs.jsx';
import CustomerAddress        from './CustomerAddress.jsx';
import CustomerPaymentMethod  from './CustomerPaymentMethod.jsx';
import OrderHistory           from './OrderHistory.jsx';
import CreditHistory          from './CreditHistory.jsx';
import BoxDeclineHistory      from './BoxDeclineHistory.jsx';
import MembershipDetails      from './MembershipDetails.jsx';
import { navigate } from '../modules/high_level_actions';

class ModalCustomer extends Component {

  constructor(props){
    super(props);
  }

  render() {
    let nAccountBalance = this.props.customer.balance,
        oOtherHistory;

    let payBalance = <div></div>;
    let {dispatch} = this.props;
    if(this.props.storeType === "Neglite") oOtherHistory = (<CreditHistory /> );
    else oOtherHistory = (<BoxDeclineHistory />);

    if( nAccountBalance >= 1) {
      payBalance = (
        <div className="balance-box">
          <h5>Your account balance is ${nAccountBalance}.</h5>
          <a className="button btn-tertiary" href="/payment" onClick={(evt) => this.props.dispatch(navigate(evt))}>Make a payment</a>
        </div>
      )
    }

    let oCustomerPaymentMethod = (this.props.customer.status !== 'Active') ?
    <div><p>No payment method available</p></div> :
    <CustomerPaymentMethod />;

    return (
      <div className="modal-customer">
        <div className="modal-header content-max-width">
          <div className="button-wrapper">
            <button className="btn-secondary" onClick={() => dispatch( closeModal() )}>Continue shopping</button>
            <button className="btn-primary mobile-420-hide" onClick={() => dispatch( logoutStore() )}>Log Out</button>
          </div>
          <h2>Account</h2>
        </div>
        <div className="modal-body content-max-width">
          <div className="col-70">
            <div className="half-col left">
              <CustomerCore />
            </div>
            <div  className="half-col left">
              <CustomerAddress />
            </div>
            <div className="half-col">
              <h4 className="alt">Payment Information</h4>
              {oCustomerPaymentMethod}
            </div>
            {payBalance}
          </div>
          <div className="col-30">
            <MembershipDetails />
          </div>
          <div className="history-wrapper">
            <div className="half-col left">
              <OrderHistory />
            </div>
            <div className="half-col">
              {oOtherHistory}
            </div>
          </div>
        </div>
      </div>
    );
  }
};


function mapStateToProps(state){
    return {
      'customer': state.customer,
      'storeType': state.store.type
    };
}

export default connect(mapStateToProps)(ModalCustomer);


// WEBPACK FOOTER //
// ./src/components/ModalCustomer.jsx